<script>
</script>

<section class="section advantages">
	<div class="container">
		<p class="advantages__suptitle h5 tac">By optimizing and accelerating all the processes of the organization, we will help you</p>
		<h2 class="h1 advantages__title tac">Increase gross income by 3-6%</h2>
		<img src="../assets/img/chart-1.png" class="advantages__img" alt="Chart">
	</div>
	<div class="container">
		<p class="advantages__suptitle h5 tac">By optimizing and accelerating all the processes of the organization, we will help you</p>
		<h2 class="h1 advantages__title tac">Reducing costs and expenses by 3-4%</h2>
		<img src="../assets/img/chart-2.png" class="advantages__img" alt="Chart">
	</div>
	<div class="container">
		<p class="advantages__suptitle h5 tac">Eventually</p>
		<h2 class="h1 advantages__title tac">You will receive a net profit increase of 6-10% </h2>
		<img src="../assets/img/chart-3.png" class="advantages__img" alt="Chart">
	</div>
</section>

<style>
	.advantages {
		background: url('../assets/img/advantages-two.png') no-repeat;
		background-size: cover;
		background-position: right;
		background-attachment: fixed;
	}
	.advantages > .container {
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.advantages__suptitle {
		color: var(--text-color-white);
		max-width: 400px;
	}
	.advantages__title {
		margin: 70px auto 75px;
		max-width: 520px;
		color: var(--text-color-white);
	}
	.advantages__img {
		margin: 0 auto;
		max-width: 100%;
	}
	.tac {
		text-align: center;
	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
	}
	@media(max-width: 1200px) {
		.container {
			max-width: 940px;
		}
		.section {
			padding: 120px 0;
		}
		.advantages__title {
			margin: 60px auto 100px;
		}
	}
	@media(max-width: 960px) {
		.container {
			max-width: 620px;
		}
		.advantages__title {
			font-size: 32px;
			line-height: 40px;
		}
	}
	@media(max-width: 640px) {
		.container {
			max-width: 460px;
		}
		.advantages__title {
			margin: 50px auto;
		}
		.advantages__suptitle {
			font-size: 14px;
			line-height: 17px;
		}
	}
	@media(max-width: 480px) {
		.advantages__title {
			font-size: 24px;
			line-height: 30px;
		}
		.container {
			max-width: 300px;
		}
		.advantages__title {
			margin: 20px auto 70px;
		}
		.advantages__img {
			height: 130px;
		}
	}
</style>